export const defaultData = {
  engineerDetails: {
    engineerName: '',
    gasSafeNumber: '',
    boatOrCaravanAccreditation: 'CCLP1 (Boats / Caravan LPG)',
    companyName: '',
    companyAddress: '',
    telephone: ''
  },
  craftOrCaravanDetails: {
    craftType: 'Narrowboat / Inland Waterway (BSS)',
    craftNameOrReg: '',
    makeAndModel: '57ft Cruiser Stern Narrowboat',
    mooringOrSiteLocation: 'Grand Union Marina',
    ownerName: '',
    ownerAddress: '',
    inspectionDate: new Date().toISOString().split('T')[0]
  },
  lpgLockerAndSupply: {
    gasLockerVapourTight: 'Yes - Fully Vapour-Tight',
    overboardDrainClear: 'Pass - Clear Overboard',
    cylinderSecuredUpright: 'Yes',
    marineRegulatorType: 'Clesse Marine Grade 30mbar (BS EN 12864 Annex M)',
    flexibleHoseConditionAndDate: 'Pass - In Date',
    bubbleLeakDetectorFitted: 'Yes - No Bubbles Observed (Pass)'
  },
  pipeworkAndTightness: {
    pipeworkMaterial: 'Seamless Copper (Sheathed / Clipped)',
    emergencyShutOffAccessible: 'Yes - Labelled',
    operatingPressureMbar: 30.0,
    tightnessTestResult: 'Pass (0.0 mbar drop)',
    tightnessDropRecordedMbar: 0.0,
    coAlarmFitted: 'Yes - In Date & Tested'
  },
  appliances: {
    cookerMakeModel: 'Thetford Caprice LPG 4-Burner Cooker & Oven',
    cookerFfd: 'Pass (All Burners FFD Protected)',
    waterHeaterMakeModel: 'Morco D61B / Truma Ultrastore LPG',
    waterHeaterFlueAndFfd: 'Pass - Room Sealed Flue OK',
    spaceHeaterMakeModel: 'Propex Heatsource HS2000',
    spaceHeaterFlueAndFfd: 'Pass',
    refrigeratorMakeModel: 'Dometic 3-Way Absorption RM Series',
    refrigeratorRoomSealed: 'Pass - Sealed to Living Area'
  },
  verdictAndSignatures: {
    overallAssessment: 'SATISFACTORY - SAFE FOR USE (BSS / EN ISO 10239 PASS)',
    remedialWorkNotes: 'Marine LPG system inspected in full compliance with BS EN ISO 10239 and Boat Safety Scheme (BSS) requirements.',
    nextInspectionDueDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    engineerSignature: '',
    ownerSignature: ''
  }
};

export default defaultData;
